<div>
  <ion-item class="ion-text-center no-results">
    <h2 class="ion-text-center">
      End of results.
    </h2>
  </ion-item>
  <ion-item>
    <p class="ion-text-wrap help-text">
      Didn't find what you were looking for? Contact our support team.
      <a
        href="mailto:advisors@amopportunities.org?subject=Could not find what I was looking for in Search.">advisors&#64;amopportunities.org</a>.
    </p>
  </ion-item>
</div>